import Vue from 'vue'
import config from '@/constants/config';
import * as helpers from '@/utils/helpers'

import Web3 from 'web3'
import { contractAbis, susd, infura_url, multicall_address, multicall_abi, ERC20_abi, yERC20_abi } from '@/constants/abis'
import { chunkArr } from '../../utils/helpers'
import BN from 'bignumber.js'
import { contract } from '../../contract'

export async function totalBalances() {

    let total = 0;
    if (config.blockchainId == 'ethereum') {

        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVL`), 300);
        let res = await req.json();

        total = (
            parseFloat(res.data.tvl) +
            parseFloat(res.data.sideChainTVL)
        );

    } else if (config.blockchainId == 'polygon') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLPolygon`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.blockchainId == 'fantom') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLFantom`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.blockchainId == 'xdai') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLxDai`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.blockchainId == 'avalanche') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLAvalanche`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.blockchainId == 'harmony') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLHarmony`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.blockchainId == 'optimism') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLOptimism`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.blockchainId == 'arbitrum') {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVLArbitrum`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    } else if (config.apiEndpoint) {
        let req = await helpers.retry(fetch(`https://api.curve.finance/api/getTVL${config.apiEndpoint}`), 300);
        let res = await req.json();
        total = parseFloat(res.data.tvl)
    }
    state.total = total
    //	console.log('TOTAL ==========>',total);
    return total
}

export let state = Vue.observable({
    total: null,
})
